import {type VesselTag, type VesselTagResponse} from '../../../api/vessels/vessel-tags'
import {type ErrorObject} from './action-creators'

export function formatVesseltagsForUI(vesselTag: VesselTagResponse): VesselTag {
    return {
        identity: vesselTag.tagIdentity,
        name: vesselTag.tagName,
    }
}

export function getTheErrorCodes(errorResult: ErrorObject | undefined): boolean {
    if (!errorResult?.error) {
        return false
    }

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    switch (Object.keys(errorResult.error)?.[0]) {
        case '1002':
        case '1004':
        case '1006':
            return true
        default:
            return false
    }
}

export function displayErrorMessage(data?: ErrorObject): string {
    if (!data?.error) {
        return ''
    }

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return data?.error[Object.keys(data?.error)[0]]
}
